import * as React from 'react';
import { connect } from 'react-redux';

import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import { isDisableUnreadMessagesSelector } from 'selectors/disableUnreadMessages';

import { t } from 'utils/language';

import type { SyntheticEvent } from 'react';

type OwnProps = {
  filterByType: string,
  onClick: (filterType: string) => void
};

type StateProps = {
  disableUnreadMessages: boolean
};

type Props = OwnProps & StateProps;

class MessengerFilterByType extends React.PureComponent<Props> {
  handleFilterChanged = (event: SyntheticEvent<HTMLElement>): void => {
    const { onClick } = this.props;
    const target = event.currentTarget;
    const filterByType = target.dataset.arg;

    if (onClick && filterByType) {
      onClick(filterByType);
    }
  };

  renderFilter(): React.ReactNode {
    const { filterByType, disableUnreadMessages } = this.props;

    const tabItems = ['all', 'unread']
      .filter(type => !(type === 'unread' && disableUnreadMessages))
      .map(type => ({
        handleClick: this.handleFilterChanged,
        handleClickArg: type,
        label: t(`messenger.filters.label_messages_${type}`),
        isActive: type === filterByType
      }));

    return (
      <div className="messenger-filter-by-type__tabs">
        <TabsUnderlined
          items={tabItems}
          size="inherit"
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div
        className="messenger-filter-by-type"
        data-qa="messenger-filter-by-type"
      >
        {this.renderFilter()}
      </div>
    );
  }
}

const mapStateToProps = ({ account, runtimeConfig }): StateProps => ({
  disableUnreadMessages: isDisableUnreadMessagesSelector({ runtimeConfig, account })
});

export default connect(mapStateToProps)(MessengerFilterByType);
